import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Input = forwardRef(
  (
    {
      type = 'text',
      value,
      onChange,
      onKeyDown,
      placeholder,
      className = '',
      size = 'medium',
      error = false,
      disabled = false,
      icon = null,
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      small: 'py-2 pr-10 pl-3 text-sm',
      medium: 'py-3 pr-10 pl-4 text-base',
      large: 'py-4 pr-12 pl-5 text-lg',
    }

    return (
      <div className="relative w-full">
        <input
          ref={ref}
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          className={clsx(
            'w-full font-inherit rounded-md border transition-all outline-none bg-white text-gray-700',
            'placeholder:text-gray-400 placeholder:opacity-100',
            sizeClasses[size],
            {
              'focus:ring-2 ring-blue-200': !error && !disabled,
              'border-danger focus:ring-2 ring-red-200': error,
              'opacity-65 cursor-not-allowed bg-gray-200 border-gray-300': disabled,
              'bg-light border-border cursor-default': props.readOnly,
            },
            className
          )}
          {...props}
        />
        {icon && (
          <div className="absolute inset-y-0 right-3 flex items-center text-gray-500 cursor-pointer">{icon}</div>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  icon: PropTypes.node,
}

export default Input
